/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListSqlConnectorsResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ListSqlConnectorsResponse } from '../../models/index.js';
// @ts-ignore
import { type WithConnectorItemRequestBuilder, WithConnectorItemRequestBuilderNavigationMetadata, WithConnectorItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { RegisterRequestBuilderRequestsMetadata, type RegisterRequestBuilder } from './register/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/sql-connector
 */
export interface SqlConnectorRequestBuilder extends BaseRequestBuilder<SqlConnectorRequestBuilder> {
    /**
     * The register property
     */
    get register(): RegisterRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.sqlConnector.item collection
     * @param connectorId The connector to retrieve, as returned by the registration call.
     * @returns {WithConnectorItemRequestBuilder}
     */
     byConnectorId(connectorId: string) : WithConnectorItemRequestBuilder;
    /**
     * Returns every connector registered to the caller's organization, most recently registered first, each with the status, version and lastHeartbeatAt it last reported. The organization comes from the caller's credentials, so there is nothing to pass; an organization with no connectors gets an empty list rather than 404. The result is capped at 100 connectors and is not paged.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListSqlConnectorsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListSqlConnectorsResponse | undefined>;
    /**
     * Returns every connector registered to the caller's organization, most recently registered first, each with the status, version and lastHeartbeatAt it last reported. The organization comes from the caller's credentials, so there is nothing to pass; an organization with no connectors gets an empty list rather than 404. The result is capped at 100 connectors and is not paged.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SqlConnectorRequestBuilderUriTemplate = "{+baseurl}/api/sql-connector";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SqlConnectorRequestBuilderNavigationMetadata: Record<Exclude<keyof SqlConnectorRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byConnectorId: {
        requestsMetadata: WithConnectorItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithConnectorItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["connectorId"],
    },
    register: {
        requestsMetadata: RegisterRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SqlConnectorRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SqlConnectorRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListSqlConnectorsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
